export type ManageMyDonationsProps = {
  donationInfo: DonationInfo
  passportActivationStatus: string | undefined
  handleButtonEnter: (arg0: ManageDonationComponentsEnums) => void
}

type DonationInfo = {
  amount?: string
  callSignStation: string
  interval?: string
  isActive?: string
  memberDate?: string
  nextBilling?: string
  shortNameStation: string
  subscriptionId: string
}

export type CancelDonationProps = {
  donationInfo: DonationInfo
  handleButtonEnter: (arg0: ManageDonationComponentsEnums) => void
}

export type ConfirmDonationProps = {
  donationInfo: DonationInfo
}

export enum DonationStatus {
  active = 'active',
  canceled = 'canceled',
  pastDue = 'past_due',
  pending = 'pending',
  suspended = 'suspended',
}

export enum passportStatus {
  activated = 'ACTIVATED',
  pending = 'PENDING',
  noMembership = 'NO_MEMBERSHIP',
}

export enum ManageDonationComponentsEnums {
  ROOT = '',
  CANCEL_DONATION = 'cancel-donation',
  CONFIRM_DONATION_CANCELATION = 'confirm-cancel-action',
}
